<template>
  <el-form :model="outData" :ref="reform" :label-width="labelWidth?labelWidth+'px':'140px'" class="my_el_form"
    :rules="formRule" :label-position="labelPosition">
    <div class="form_item" v-for="(item,index) in formData" :key="index">
      <el-form-item v-if="item.type=='input'" :label="item.name" :prop="item.field" :required="item.required">
        <el-input :style="{ width:item.width?item.width+'px':'485px'}" v-input-filter
          :placeholder="item.placeholder?item.placeholder:'请输入内容'" v-model="outData[item.field]"
          :disabled="item.disabled" :maxlength="item.maxlength?item.maxlength:36" :type="item.password ? 'password' : 'text'" :show-password="item.showPassword ? item.showPassword : false">
          <i slot="suffix" v-if="item.slot" class="input_slot">{{item.slotName}}</i>
          <i slot="suffix" v-if="item.icon" class="input_slot" :class="item.icon" @click="response"></i>
           <el-button v-if="item.btn" slot="append" :icon="item.iconfont" @click="response"></el-button>
          </el-input>
      </el-form-item>
      <el-form-item v-if="item.type=='blank'" :label="item.name" :prop="item.field" :required="item.required">
        <div :style="{ width:item.width?item.width+'px':'485px'}"></div>
      </el-form-item>
      <el-form-item v-if="item.type=='numberWord'" :label="item.name" :prop="item.field" :required="item.required">
        <el-input :style="{ width:item.width?item.width+'px':'485px'}"
          :placeholder="item.placeholder?item.placeholder:'请输入内容'" v-model="outData[item.field]"
          v-input-filter:numberWord :disabled="item.disabled" :maxlength="item.maxlength?item.maxlength:36">
          <i slot="suffix" v-if="item.slot" class="input_slot">{{item.slotName}}</i></el-input>
      </el-form-item>
      <el-form-item v-if="item.type=='numberInput'" :label="item.name" :prop="item.field" :required="item.required">
        <el-input :style="{ width:item.width?item.width+'px':'485px'}"
          :placeholder="item.placeholder?item.placeholder:'请输入正整数'" v-model="outData[item.field]"
          onkeyup="this.value=this.value.replace(/[^\d.]/g,'');" :maxlength="item.maxlength?item.maxlength:'4'"
          :disabled="item.disabled" >
          <i slot="suffix" v-if="item.slot" class="input_slot">{{item.slotName}}</i></el-input>
      </el-form-item>
      <el-form-item v-if="item.type=='decimalInput'" :label="item.name" :prop="item.field" :required="item.required">
        <el-input :style="{ width:item.width?item.width+'px':'485px'}"
          :placeholder="item.placeholder?item.placeholder:'请输入小数'" v-model="outData[item.field]"
          v-only-number="{max:100000000,min:0,precision:item.maxlength}" :disabled="item.disabled">
          <i slot="suffix" v-if="item.slot" class="input_slot">{{item.slotName}}</i></el-input>
      </el-form-item>
      <el-form-item v-if="item.type=='selectInput'" :label="item.name" :prop="item.field" :required="item.required">
        <el-input :style="{ width:item.width?item.width+'px':'485px'}" v-if="item.differ"
          :placeholder="item.placeholder?item.placeholder:'请输入内容'" v-model="outData[item.field]">
          <el-select v-model="outData[item.selectField]" slot="append" placeholder="" :style="{ width:item.selectWidth?item.selectWidth +'px': '80px'}">
            <el-option v-for="child in item.options" :key="child.value" :label="child.label" :value="child.value">
            </el-option>
          </el-select>
        </el-input>
        <template v-else>
          <el-select v-model="outData[item.selectField]" placeholder="" :style="{ width:'120px'}">
            <el-option v-for="child in item.options" :key="child.value" :label="child.label" :value="child.value">
            </el-option>
          </el-select>
        <el-input :style="{ width:item.width?item.width+'px':'485px'}"
          :placeholder="item.placeholder?item.placeholder:'请输入内容'" v-model="outData[item.field]">
           <i slot="suffix" v-if="item.slot" class="input_slot">{{item.slotName}}</i>
           <i slot="suffix" v-if="item.iconfont" class="input_slot" :class="item.iconfont" @click="response"></i>
          <el-button v-if="item.btn" slot="append" :icon="item.icon" @click="response"></el-button>
        </el-input>
        </template>
      </el-form-item>
      <el-form-item v-else-if="item.type=='select'" :label="item.name" :prop="item.field" :required="item.required"
        v-show="!item.isshow">
        <el-select v-model="outData[item.field]" :multiple="item.multiple?item.multiple:false" @change="response"
          :disabled="item.disabled" :filterable="item.filterable?item.filterable:false"
          :style="{ width:item.width?item.width+'px':'485px'}">
          <el-option v-for="item in item.options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-else-if="item.type=='cascader'" :label="item.name" :prop="item.field" :required="item.required"
        v-show="!item.isshow">
        <el-cascader v-model="outData[item.field]" :options="item.options" :props="item.defaultParams"
          @change="response" :show-all-levels="item.showAll" :disabled="item.disabled"
          :style="{ width:item.width?item.width+'px':'485px'}"></el-cascader>
      </el-form-item>
      <el-form-item v-else-if="item.type=='cascaderInput'" :label="item.name" :prop="item.field" :required="item.required"
        v-show="!item.isshow">
        <el-cascader v-model="outData[item.field]" :class="item.class" :options="item.options" :props="item.defaultParams"
          @change="response" :show-all-levels="item.showAll" :disabled="item.disabled"
          :style="{ width:item.width?item.width+'px':'200px'}"></el-cascader>
          <el-input :style="{ width:item.width?item.width+'px':'200px'}" v-input-filter
          :placeholder="item.placeholder?item.placeholder:'请输入内容'" v-model="outData[item.fieldData]"
          :disabled="item.disabled" :maxlength="item.maxlength?item.maxlength:36" :type="item.password ? 'password' : 'text'" :show-password="item.showPassword ? item.showPassword : false">
          </el-input>
      </el-form-item>
      <el-form-item v-else-if="item.type=='textarea'" :label="item.name" :prop="item.field" :required="item.required">
        <el-input :style="{ width:item.width?item.width+'px':'485px'}" type="textarea"
          :placeholder="item.placeholder?item.placeholder:'请输入内容'" v-model="outData[item.field]"></el-input>
      </el-form-item>
      <el-form-item v-else-if="item.type=='checkbox'" :label="item.name" :prop="item.field" :required="item.required">
        <el-checkbox-group v-model="outData[item.field]">
          <el-checkbox v-for="(checkedItem,index) in item.options" :label="checkedItem.value" :key="index">
            {{checkedItem.label}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item v-else-if="item.type=='radio'" :label="item.name" :prop="item.field" :required="item.required">
        <el-radio-group v-model="outData[item.field]"  :style="{ width:item.width?item.width+'px':'485px'}">
          <el-radio v-for="(checkedItem,index) in item.options" :label="checkedItem.value" :key="index">
            {{checkedItem.label}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-else-if="item.type=='date'" :label="item.name" :prop="item.field">
        <el-date-picker v-model="outData[item.field]" type="date" placeholder="选择日期" value-format="timestamp"
          :picker-options="item.pickerOptions" :format="item.format?item.format:'yyyy - MM - dd'"
          :style="{ width:item.width?item.width+'px':'485px'}" suffix-icon="el-icon-date" @change="dateChange">
        </el-date-picker>
      </el-form-item>
      <el-form-item v-else-if="item.type=='datetime'" :label="item.name" :prop="item.field" :required="item.required">
        <el-date-picker v-model="outData[item.field]" type="datetime" placeholder="选择日期时间" value-format="timestamp"
          :picker-options="item.pickerOptions" :format="item.format?item.format:'yyyy - MM - dd  HH : mm : ss'"
          :style="{ width:item.width?item.width+'px':'485px'}" suffix-icon="el-icon-date" @change="dateChange">
        </el-date-picker>
      </el-form-item>
      <el-form-item v-else-if="item.type=='string'" :label="item.name">
        <el-input :style="{ width:item.width?item.width+'px':'485px'}" readonly disabled
          :placeholder="item.placeholder?item.placeholder:''" v-model="outData[item.field]">
        </el-input>
      </el-form-item>
      <el-form-item v-else-if="item.type=='selectDateType'" :label="item.name" :prop="item.field">
        <el-select v-model="outData[item.field]" :multiple="item.multiple?item.multiple:false" @change="dateTypeChange"
          :filterable="item.filterable?item.filterable:false" :style="{ width:item.width?item.width+'px':'485px'}">
          <el-option v-for="item in item.options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-else-if="item.type=='selectDatePicker'" :label="item.name" :prop="item.field">
        <div class="dateList">
          <div class="dateItem">
            <el-date-picker v-model="outData[item.field]" type="datetimerange" placeholder="选择日期"
              :picker-options="item.pickerOptions" value-format="timestamp" format="yyyy - MM - dd"
              :style="{ width:item.width?item.width+'px':'485px'}" suffix-icon="el-icon-date">
            </el-date-picker>
          </div>
        </div>
      </el-form-item>
      <el-form-item v-else-if="item.type=='selectDaterange'" :label="item.name" :required="item.required" :prop="item.field">
        <div class="dateList">
          <div class="dateItem">
            <el-date-picker v-model="outData[item.field]" type="daterange" start-placeholder="开始日期" range-separator="至"
                  end-placeholder="结束日期" :picker-options="item.pickerOptions" value-format="timestamp" format="yyyy - MM - dd"
              :style="{ width:item.width?item.width+'px':'485px'}" suffix-icon="el-icon-date">
            </el-date-picker>
          </div>
        </div>
      </el-form-item>
      <el-form-item v-else-if="item.type=='radioLink'" :label="item.name" :prop="item.field">
        <div>
          <el-radio-group v-model="outData[item.field]" :style="{ width:item.width?item.width+'px':'485px'}">
            <el-radio v-for="(checkedItem,index) in item.option" :label="checkedItem.value" :key="index">
              {{checkedItem.label}}</el-radio>
          </el-radio-group>
        </div>
        <div v-if="outData[item.field] == 3">
          <el-select v-model="outData[item.field1]" :multiple="item.multiple?item.multiple:false"
            :filterable="item.filterable?item.filterable:false" :style="{ width:item.width?item.width+'px':'485px'}">
            <el-option v-for="item in item.options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </el-form-item>
    </div>
  </el-form>
</template>
<script>
  import FormValidate from '../../utils/formValidate';
  export default {
    props: {
      labelWidth: null,
      labelPosition:{
        type: String,
        default: function() {
          return "right"
        }
      },
      reload: '',
      reform: {
        type: String,
        default: function () {
          return 'alform'
        }
      },
      formRule: {
        type: Object,
        default: function () {
          return {
            // username: [{
            //   validator: FormValidate.username,
            //   required: true,
            //   trigger: 'blur'
            // }],
          }
        }
      },
      formData: {
        type: Array,
        default: function () {
          return [{
              type: "input", //普通输入框
              field: "id",
              name: "员工ID",
              icon: '2',
              dataType: 'string'
            },
            {
              type: "select", //普通下拉框
              field: "type",
              name: "告警类型",
              filterable: true, //可搜索
              options: [],
              dataType: 'string',
              optionCallback: function (value) {
                return value + "hh"
              },
              ajax: {
                url: this.$url.getPageList, //url地址
                data: {}, //参数
                label: 'parkName', //key的字段
                value: 'parkCode', //value的字段
              }
            },
            {
              type: "textarea", //时间范围搜索
              field: "textarea",
              name: "文本框",
              dataType: 'string'
            },
            {
              type: "checkbox", //普通下拉框
              field: "checkbox",
              name: "职位",
              options: [],
              dataType: 'array',
              optionCallback: function (value) {
                return value + "hh"
              },
              ajax: {
                url: this.$url.getPageList, //url地址
                data: {}, //参数
                label: 'parkName', //key的字段
                value: 'parkCode', //value的字段
              }
            },
          ]
        },
      }
    },
    data() {
      return {
        dateType: 'day',
        outData: {},
        string: '',
      };
    },
    mounted() {
      this.init();
      // console.log(this.outData)
    },
    methods: {
      init() {
        let outData = {};
        for (let i in this.formData) {
          let _data = this.formData[i];
          // console.log(_data)
          if (_data.ajax != null) {
            this.$axios.ajax({
              method: _data.ajax.method ? _data.ajax.method : "get",
              url: _data.ajax.url,
              data: _data.ajax.data
            }).then((res) => {
              let lab = _data.ajax.label;
              let val = _data.ajax.value;
              let list = res.data;
              if (_data.ajax.callback && typeof (_data.ajax.callback) === 'function') {
                // console.log(1321)
                list = _data.ajax.callback(list)
              } else {
                // console.log("================")`
              }
              if (list != null) {
                let options = [];
                if (_data.type == 'cascader') {
                  options = list
                } else {
                  for (let item of list) {
                    options.push({
                      label: item[lab],
                      value: item[val]
                    });
                  }
                }

                this.formData[i].options = options;
                 console.log(this.formData)
                if (!this.formData[i].value && options.length > 0 && _data.type == 'select') {
                  if (_data.dataType == 'array') {
                    // this.formData[i].value = [ options[0].value]
                  } else {
                      this.formData[i].value = options[0].value;
                  }
                }
              }
            }).catch((error) => {
              console.log(error);
            })
          }
          outData[_data.field] = _data.value;
          if (_data.type == 'date') {
            this.dateChange(_data.value)
          }
          if (_data.type == 'selectInput') {
            // console.log(_data)
            outData[_data.selectField] = _data.options[0].value;
          }
          if (_data.type == 'radio') {
            // console.log(_data)
            outData[_data.field] = _data.options[0].value;
          }
        }
        this.emptyData = Object.assign({}, outData)
        this.outData = outData;

      },
      oninput(e) {
        console.log(e.target.value)
      },
      dateChange(data) {
        let dateObj = new Date().getTime()
        var days = parseInt(dateObj / (1000 * 60 * 60 * 24));
        var day2 = parseInt(data / (1000 * 60 * 60 * 24));
        if (days - day2) {
          this.string = days - day2 + '天'
        } else {
          this.string = '0天'
        }
      },
      initData(data) {
        this.outData[data.key] = data.value
      },
      dateTypeChange(data) {
        this.dateType = data
      },
      submitForm() {
        let flag = false
        this.$refs[this.reform].validate((valid) => {
          if (valid) {
            flag = true
          } else {
            console.log('error submit!!');
            flag = false
          }
        })
        if (flag) {
          return this.outData
        } else {
          return false
        }
      },
      resetForm() {
        this.$refs[this.reform].resetFields();
        console.log(999999)
        // this.init();
      },
      response() {
        this.$emit('response', this.outData)
        return this.outData
      }
    },
    watch: {
      reload: {
        handler(newV, oldV) {
          this.init();
        },
        deep: true
      }
    }
  }

</script>
<style scoped>
  .my_el_form {
    display: flex;
    flex-wrap: wrap;
  }

  .form_item {
    display: flex;
  }

  .input_slot {
    /* background: #ebebeb; */
  }
  

</style>
<style lang="less" scoped>

</style>
